module.exports = __webpack_public_path__ + "static/media/highlight-diamond.6195f415.svg";